@use 'src/global/variables.scss' as var;

.multiple-choice-button {
  font-size: 16px;
  padding: 8px 16px;
  background: #D9E1ED;
  color: var.$primary-color;
  border: 1px solid transparent;
  box-shadow: var.$message-screen-elements-box-shadow;
  cursor: pointer;
  margin: 2px;
  border-radius: 5px;
  width: calc(100% - 24px);
  // Firefox on Windows displays an additional border around focused elements

  &.small {
    margin: 1%;
  }

  &::-moz-focus-inner {
    border: 0;
  }

  &:hover,
  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px var.$focus-color;
    border: 1px solid var.$focus-color;
  }
}
